<template>
    <div class="cart">
        <!--Top Bar-->
        <TopBar msg="Welcome to Your Vue.js App" />
        <!--Top Bar-->

        <v-divider></v-divider>

        <v-card elevation="0"
            class="bg-secondary mx-auto rounded-xl mt-n6 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none "
            height="120">
            <div class="d-flex flex-column fill-height justify-center align-center text-black">
                <h1 class="mobile-category-title-text">
                    Login
                </h1>
            </div>
        </v-card>

        <v-container>
            <v-row dense class="bg-white">
                <v-col cols="12" sm="12" md="12">
                    <v-card class="mx-auto bg-white" elevation="0" min-height="500" max-width="1100">
                        <div class="d-flex flex-column text-left text-black ml-2">
                            <h1
                                class="d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block  font-weight-bold mt-4 ml-4">
                                Login
                            </h1>

                        </div>
                        <v-row dense>
                            <v-col cols="12" sm="7" md="7">

                                <!--alert box-->
                                <v-alert type="error" class="text-left ma-5" border v-if="loginStatusmsg">
                                    <div v-for="(resp, i) in loginStatusResponse" :key="i">
                                        {{ resp }}
                                    </div>
                                </v-alert>
                                <!--alert box end-->


                                <v-card class="ma-4 rounded-xl pa-5" elevation="0" variant="outlined"  >
                                    <form class="mt-5">

                                        <v-text-field v-model="mobileno"
                                            :error-messages="v$.mobileno.$errors.map(e => e.$message)" :counter="10"
                                            label="Mobile no" required @input="v$.mobileno.$touch" @blur="v$.mobileno.$touch"
                                            variant="outlined" color="black" type="number" class="mb-2" ></v-text-field>

                                        <v-text-field v-model="password"
                                            :error-messages="v$.password.$errors.map(e => e.$message)" label="Password"
                                            required @input="v$.password.$touch" @blur="v$.password.$touch"
                                            variant="outlined" color="black" type="password" class="mb-2"></v-text-field>



                                        <v-btn
                                            class="text-none text-subtitle-2 font-weight-bold mb-5 cart-btn float-md-left"
                                            color="primary" rounded variant="flat" width="220" @click="submit">
                                            <p class="text-white"> LOGIN</p>
                                        </v-btn>

                                        <!--<v-btn class="text-none text-subtitle-2 font-weight-bold mb-5 cart-btn "
                                            color="black" width="220" rounded variant="flat" href="/register">
                                            <p class="text-white"> REGISTER</p>
                                        </v-btn>-->

                                        <v-card class="mx-auto bg-white mt-4" elevation="0">
                                            <p color="black" class="text-subtitle-1 font-weight-bold"> New User? Click here
                                                to
                                                <span class="text-decoration-underline" color="black"
                                                    @click="registerRedirect">Register</span>
                                            </p>

                                        </v-card>


                                    </form>
                                </v-card>
                            </v-col>

                        </v-row>
                    </v-card>
                </v-col>

            </v-row>
        </v-container>

        <AppFooter />



    </div>
</template>
  


<style>
.cart-btn {
    letter-spacing: 0px !important;
    font-size: 14px !important;
    height: 48px !important;
}
</style>

<script >
// @ is an alias to /src

import TopBar from '@/components/Bar.vue'

import AppFooter from '@/components/Footer.vue'

import { useVuelidate } from '@vuelidate/core'
import { required, numeric, minLength, maxLength, helpers } from '@vuelidate/validators'
import { mapActions, mapGetters } from "vuex";
import router from "../router";
export default {
    name: 'LoginView',
    setup: () => ({ v$: useVuelidate() }),
    data: () => ({
        timeout: 2000,
        mobileno: '',
        password: ''
    }),
    validations() {
        return {

            mobileno: {
                required: helpers.withMessage('This field cannot be empty', required),
                numeric,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            password: { required: helpers.withMessage('This field cannot be empty', required) }
        }
    },
    components: {
        TopBar,
        AppFooter,

    },
    computed: {
        ...mapGetters([
            "getLoginStatus",
            "getLoginResponse",
        ]),

        loginStatusmsg: function () {
            return this.getLoginStatus === "error";
        },
        loginStatusResponse: function () {
            return this.getLoginResponse;
        }
    },
    methods: {
        ...mapActions(["loginAction"]),
        async submit() {
            await this.v$.$validate()
            // const result = await this.v$.$validate()
            // if (!result) {
            //     // notify user form is invalid
            //     console.log('enter');
            //     return
            // }
            if (this.v$.mobileno.$invalid ||
                this.v$.password.$invalid) {
                // notify user form is invalid
                console.log('enter');
                return
            }
            // perform async actions

            const loginData = {
                mobileno: this.mobileno,
                password: this.password
            };

            //console.log(customerData);
            this.loginAction(loginData);
        },
        registerRedirect() {

            router.push("/register");
        }
    },

}
</script>
